/**
 * Preferences provider
 *
 * @module app/components/PreferencesProvider
 */
import StorageProvider from './StorageProvider';
import Translator from './Translator';

/**
 * Methods to be public
 *
 * @type {Object}
 */
var api = {

    /**
     * Get user timezone based on SportsbookAPI
     *
     * @returns {Object}
     *
     * @public
     */
    getTimezone: function () {

        if (window.document.sportsbookAPI) {
            return window.document.sportsbookAPI.getCustomerTimeZone();
        }

        return null;
    },

    /**
     * Retrieve timestamp for current user
     *
     * @returns {Number}
     *
     * @public
     */
    getTimestamp: function () {

        if (window.hasOwnProperty('WH') && window.WH.hasOwnProperty('sportsbook') &&
            window.WH.sportsbook.hasOwnProperty('env') && window.WH.sportsbook.env === 'test') {
            return 1401314400000;
        }
        return Date.now();
    },

    /**
     * Get locale from OpenBet function or return a default value
     *
     * @returns {String}
     *
     * @public
     */
    getLocaleFromOpenBet: function () {

        return window.document.sportsbookAPI.getCustomerLocale() || 'en-gb';
    },

    /**
     * Retrieve user locale based on SportsbookAPI
     *
     * @returns {String}
     *
     * @public
     */
    getLocale: function () {

        return Translator.getLocale();
        /*
        We need to identify if we still need the preferences from openbet
        if (window.document.sportsbookAPI) {
            return api.getLocaleFromOpenBet();
        }
        return 'en-gb';
        */
    },

    /**
     * Set preference
     *
     * @param   {String} key
     * @param   {Mixed}  value
     *
     * @returns {void}
     *
     * @public
     */
    setPreference: function (key, value) {

        return StorageProvider.set(key, value);
    },

    /**
     * Get preference
     *
     * @param   {String} key
     *
     * @returns {String}
     *
     * @public
     */
    getPreference: function (key) {

        return StorageProvider.get(key);
    },
};

export default api;
